import { forwardRef, useState } from "react";
import { TextField, Grid, InputAdornment } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import {
  Supplier,
  setInitialBalanceDialog,
} from "../../../../app/slices/supplierSlice";
import { HiOutlineWallet } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const NumericFormatCustom = forwardRef(function NumericFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
    />
  );
});

const InitialSupplierBalanceForm = () => {
  const _InitialSupplierBalance = useSelector(
    (state) => state.supplier.initialBalance
  );
  const _SearchBody = useSelector((state) => state.supplier.searchBody);

  const { control, handleSubmit } = useForm({
    defaultValues: _InitialSupplierBalance.form,
  });

  const [saving, setSaving] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    setSaving(true);
    try {
      await dispatch(
        Supplier.initialBalance(
          _InitialSupplierBalance.supplier_id,
          data,
          _SearchBody
        )
      );
    } finally {
      setSaving(false);
    }
  };

  const handleClose = () => {
    dispatch(setInitialBalanceDialog(null));
  };

  return (
    <FormDialog
      open={_InitialSupplierBalance.dialog}
      onClose={handleClose}
      icon={<HiOutlineWallet />}
      title="أضافة رصيد للمورد"
      subtitle="حدد المبلغ الذي سيضاف الى رصيد المورد"
      onSubmit={handleSubmit(onSubmit)}
      saving={saving}
    >
      <SectionCard icon={<HiOutlineWallet />} title="الرصيد">
        <Grid item xs={12}>
          <Controller
            name="balance"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="الرصيد"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default InitialSupplierBalanceForm;
